// extracted by mini-css-extract-plugin
export default {"item":"Przepv"};